<template>
  <v-row class="ma-0 pa-0" align="center" justify="center">
    <v-col :cols="nocharge ? 12 : 3" class="pa-0" align="center">
      <div :style="getIconStyle()">
        <template v-if="getAvatar(item)">
          <img :style="getIconStyle()" :src='getAvatar(item)'>
        </template>
        <p v-else class="select-none" :style="getIconTextStyle()" >{{ getNamePrefix(item) }}</p>
      </div>
    </v-col>
    <v-col v-if="!nocharge" cols="9" class="py-0 pl-1 pr-0" align="center">
      <div :style="'height: ' + this.height + 'px; ' + 'width: 100%;'">
        <p class="select-none" :style="getChargeStyle(item)">{{ getCharge(item) }}</p>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      users: 'users/users',
      groups: 'groups/groups'
    })
  },
  data () {
    return {
    }
  },
  props: [ 'item', 'size', 'height', 'nocharge' ],
  methods: {
    getIconTextStyle () {
      const fontSize = 'font-size: ' + String(this.size - 4) + 'px; color: white; '
      const lineHeight = 'line-height: ' + String(this.height) + 'px; '
      const height = 'height: ' + String(this.height) + 'px; '
      const width = 'width: ' + String(this.height) + 'px; '
      const background = 'background-color: ' + this.getGroupColor(this.item) + ';'
      return fontSize + lineHeight + height + width + background + 'padding: 0px; margin: 0px; text-align: center; white-space: nowrap; overflow: hidden; border-radius: 50%; display: inline-block;'
    },
    getIconStyle () {
      return 'height: ' + this.height + 'px; ' + 'width: ' + this.size + 'px; border-radius: ' + this.size / 2 + 'px;'
    },
    getAvatar (item) {
      var url = null
      var keys = Object.keys(item.groups)
      for (var i in keys) {
        var index = this.groups.findIndex(g => g.key === keys[i])
        if (index !== -1) {
          if (this.groups[index].avatar) {
            return this.groups[index].avatar.thumbnail
          } else {
            break
          }
        }
      }
      return url
    },
    getNamePrefix (item) {
      var name = '？'
      var keys = Object.keys(item.groups)
      for (var i in keys) {
        var index = this.groups.findIndex(g => g.key === keys[i])
        if (index !== -1) {
          if (this.groups[index].name) {
            name = this.groups[index].name.slice(0, 1)
          } else {
            break
          }
        }
      }
      return name
    },
    getGroupColor (item) {
      var keys = Object.keys(item.groups)
      for (var i in keys) {
        var index = this.groups.findIndex(g => g.key === keys[i])
        if (index !== -1) {
          return this.groups[index].color ? this.groups[index].color : '#1976D2'
        }
      }
      return '#1976D2'
    },
    getCharge (item) {
      var index = this.users.findIndex(user => user.key === item.charge)
      if (index !== -1) {
        return JSON.parse(JSON.stringify(this.users[index].sei))
      }
      return ''
    },
    getChargeStyle (item) {
      const fontSize = 'font-size: ' + String(this.size - 5) + 'px; color: ' + this.getGroupColor(item) + '; '
      const lineHeight = 'line-height: ' + String(this.height) + 'px; '
      const height = 'height: ' + String(this.height) + 'px; '
      const width = 'width: 100%; '
      const boarder = 'border-radius: 8px; border: 1px solid ' + this.getGroupColor(item) + '; '
      const background = 'background-color: white; '
      return fontSize + lineHeight + height + width + boarder + background + 'padding: 0px !important; margin: 0px !important; text-align: middle; white-space: nowrap; overflow: hidden; display: inline-block;'
    }
  }
}
</script>

<style scoped>
.select-none {
  user-select: none;
}
</style>
